const insuredapi = [{
  desc: '报价列表',
  options: {
    url: '/insured?action=QueryInsuredPrice',
    method: 'post',
    baseURL: '/insuredapi/api'
  },
  vuex: false
}, {
  desc: '特约列表查询接口',
  options: {
    url: '/insuredbasedata?action=SpecialClauseQuery',
    method: 'post',
    baseURL: '/insuredapi/api'
  }
}, {
  desc: '特约添加接口',
  options: {
    url: '/insuredbasedata?action=SpecialClauseAddOrUpdate',
    method: 'post',
    baseURL: '/insuredapi/api'
  }
}, {
  desc: '添加特约接口（拷贝添加）',
  options: {
    url: '/insuredbasedata?action=SpecialClauseCopyAdd',
    method: 'post',
    baseURL: '/insuredapi/api'
  }
}, {
  desc: '添加/编辑报价工号配置',
  options: {
    url: '/insuredbasedata?action=InsPriceConfigAddOrUpdate',
    method: 'post',
    baseURL: '/insuredapi/api'
  }
}]
export default insuredapi



// WEBPACK FOOTER //
// ./src/api/insuredapi.js